import React from 'react';
import { FadeIn } from './Shared';
import { Scale } from 'lucide-react';
export const CostComparison = () => {
  return <section className="py-6 md:py-10 px-4 bg-navy-900" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <FadeIn data-id="element-45">
          <div className="text-center mb-8" data-id="element-46">
            <h2 className="text-xl md:text-3xl font-serif font-bold text-white flex items-center justify-center" data-id="element-47">
              <Scale className="w-8 h-8 text-gold-400 mr-4" data-id="element-48" />
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-navy-800 rounded-2xl border border-navy-700 overflow-hidden shadow-2xl" data-id="element-49">
            <div className="overflow-x-auto" data-id="element-50">
              <table className="w-full text-left border-collapse" data-id="element-51">
                <thead data-id="element-52">
                  <tr className="bg-navy-900 border-b border-navy-700" data-id="element-53">
                    <th className="py-5 px-6 text-red-400 font-bold text-lg w-1/2 border-r border-navy-700" data-id="element-54">
                      Sin MegaPack
                    </th>
                    <th className="py-5 px-6 text-gold-400 font-bold text-lg w-1/2" data-id="element-55">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-navy-700/50" data-id="element-56">
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-57">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-58">
                      Cada berrinche manejado sin sistema
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-59">
                      Culpa acumulada + vínculo desgastado
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-60">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-61">
                      Gritar más de lo que querías esta semana
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-62">
                      Lo mismo la semana que viene
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-63">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-64">
                      Ceder el límite por vergüenza en público
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-65">
                      Le enseñaste exactamente dónde está el botón
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-66">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-67">
                      No saber qué decir en el pico de la crisis
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-68">
                      Improvisación que casi siempre escala
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-69">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-70">
                      Reparar sin protocolo
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-71">
                      Conversaciones que no cierran nada
                    </td>
                  </tr>
                  <tr className="hover:bg-navy-700/30 transition-colors" data-id="element-72">
                    <td className="py-4 px-6 text-gray-100 border-r border-navy-700" data-id="element-73">
                      Domingo rumiando si lo estás haciendo bien
                    </td>
                    <td className="py-4 px-6 text-gray-200" data-id="element-74">
                      El mismo ciclo, el próximo lunes
                    </td>
                  </tr>
                </tbody>
                <tfoot data-id="element-75">
                  <tr className="bg-navy-900/80 border-t-2 border-gold-500/30" data-id="element-76">
                    <td colSpan={2} className="py-8 px-6 text-center" data-id="element-77">
                      <span className="text-2xl font-serif font-bold text-white" data-id="element-78">
                        El próximo berrinche{' '}
                        <span className="text-gold-400 italic" data-id="element-79">
                          puede terminar diferente.
                        </span>
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};